import React from 'react';
import { useTranslation } from 'react-i18next';
import '../style.css';

const InfoBeasiswa = () => {
  const { t } = useTranslation();

  const awards = [
    { percentage: '100%', label: t('info.first'), className: 'award--primary' },
    { percentage: '75%', label: t('info.second'), className: 'award--secondary' },
    { percentage: '50%', label: t('info.third'), className: 'award--tertiary' },
  ];

  return (
    <section id="info-beasiswa" className="awards-section" aria-labelledby="awards-title">
      <div className="container">
        <div className="section-kicker section-kicker--light">
          <span />
          <h2 id="awards-title">{t('info.title')}</h2>
          <span />
        </div>

        <div className="awards-grid">
          {awards.map((award) => (
            <article className={`award ${award.className}`} key={award.percentage}>
              <i className="fa-solid fa-award" aria-hidden="true" />
              <div>
                <strong>{award.percentage}</strong>
                <span>{t('info.scholarship')}</span>
                <p>{award.label}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoBeasiswa;
